(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[112],{

/***/ 2023:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/to/[to]/[id]",
      function () {
        return __webpack_require__(7212);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Breadcrumb; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


function Breadcrumb(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-primary",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
            className: "container mx-auto overflow-y-auto flex px-2 md:pl-24 py-4",
            "aria-label": "Breadcrumb",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                className: "inline-flex items-center space-x-1 md:space-x-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(BreadcrumbItem, {
                        first: true,
                        href: "/",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                className: "mr-2 w-4 h-4",
                                fill: "currentColor",
                                viewBox: "0 0 20 20",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                                })
                            }),
                            "Home"
                        ]
                    }),
                    props.items.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BreadcrumbItem, {
                            last: index === props.items.length - 1,
                            href: item.href,
                            children: item.text
                        }, index))
                ]
            })
        })
    });
}
function BreadcrumbItem(param) {
    let { href , first , last , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        "aria-current": last ? "page" : undefined,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center",
            children: [
                first || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-6 h-6 text-blue-dark",
                    fill: "currentColor",
                    viewBox: "0 0 20 20",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                        clipRule: "evenodd"
                    })
                }),
                href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: href,
                    className: "inline-flex items-center text-sm font-medium text-blue-dark hover:text-white whitespace-nowrap ml-2 first-letter:uppercase",
                    children: children
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-sm font-medium text-blue-dark whitespace-nowrap ml-2 first-letter:uppercase",
                    children: children
                })
            ]
        })
    });
}


/***/ }),

/***/ 274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Datetime; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var date_fns_parseISO__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8420);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8058);




function Datetime(props) {
    const onChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((e)=>{
        const value = e.target.value;
        const d = (0,date_fns_parseISO__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(value);
        props.onChange(d);
    }, [
        props.onChange
    ]);
    const value = props.value instanceof Date ? (0,date_fns_format__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props.value, "yyyy-MM-dd'T'HH:mm") : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.id || props.name,
                className: "block font-medium",
                children: props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-1 relative rounded-md shadow-sm flex flex-row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        name: props.name,
                        id: props.id || props.name,
                        type: "datetime-local",
                        className: "block w-full border-gray-300 rounded-md",
                        placeholder: props.placeholder,
                        value: value,
                        onChange: onChange
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "whitespace-nowrap",
                        children: Intl.DateTimeFormat().resolvedOptions().timeZone
                    })
                ]
            }),
            props.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-red-600",
                children: props.error
            })
        ]
    });
}


/***/ }),

/***/ 9262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Dropdown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function Dropdown(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.id || props.name,
                className: "block font-medium",
                children: props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-1 relative rounded-md shadow-sm",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                    name: props.name,
                    id: props.id || props.name,
                    className: "block w-full border-gray-300 rounded-md",
                    placeholder: props.placeholder,
                    value: props.value || "",
                    onChange: (e)=>props.onChange(e.target.value),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                            value: "",
                            children: props.placeholder
                        }),
                        props.options.map((opt, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                value: opt.value,
                                children: opt.label
                            }, index))
                    ]
                })
            }),
            props.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-red-600",
                children: props.error
            })
        ]
    });
}


/***/ }),

/***/ 5461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NumericInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function NumericInput(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.id || props.name,
                className: "block font-medium",
                children: props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-1 relative rounded-md shadow-sm",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    name: props.name,
                    id: props.id || props.name,
                    type: "number",
                    className: "block w-full border-gray-300 rounded-md",
                    placeholder: props.placeholder,
                    value: props.value || "",
                    onChange: (e)=>props.onChange(+e.target.value)
                })
            }),
            props.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-red-600",
                children: props.error
            })
        ]
    });
}


/***/ }),

/***/ 514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function TextInput(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.id || props.name,
                className: "block font-medium",
                children: props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-1 relative rounded-md shadow-sm",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    name: props.name,
                    id: props.id || props.name,
                    type: props.type || "text",
                    className: "block w-full border-gray-300 rounded-md",
                    placeholder: props.placeholder,
                    value: props.value || "",
                    onChange: (e)=>props.onChange(e.target.value)
                })
            }),
            props.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-red-600",
                children: props.error
            })
        ]
    });
}


/***/ }),

/***/ 4603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Textarea; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function Textarea(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.id || props.name,
                className: "block font-medium",
                children: props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-1 relative rounded-md shadow-sm",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                    name: props.name,
                    id: props.id || props.name,
                    className: "block w-full border-gray-300 rounded-md",
                    placeholder: props.placeholder,
                    value: props.value || "",
                    onChange: (e)=>props.onChange(e.target.value)
                })
            }),
            props.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-red-600",
                children: props.error
            })
        ]
    });
}


/***/ }),

/***/ 7212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5142);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6688);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9734);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4487);
/* harmony import */ var _components_Breadcrumb__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8642);
/* harmony import */ var _components_Form_Datetime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(274);
/* harmony import */ var _components_Form_Dropdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9262);
/* harmony import */ var _components_Form_NumericInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5461);
/* harmony import */ var _components_Form_Textarea__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4603);
/* harmony import */ var _components_Form_TextInput__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(514);
/* harmony import */ var utils_db__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6756);
/* harmony import */ var date_fns_parseISO__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8420);
/* harmony import */ var utils_form__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4597);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1604);
/* harmony import */ var _constants_formats__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(10);
/* harmony import */ var react_google_autocomplete__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2625);



















const AdminTournamentEdit = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const autocompleteRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const { data: organizer , isLoading: isLoadingOrganizer  } = (0,swr__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("/organizer/".concat(router.query.to), ()=>(0,utils_db__WEBPACK_IMPORTED_MODULE_12__/* .fetchOrganizer */ .bW)(router.query.to));
    const { data: tournament , isLoading: isLoadingTournament , mutate  } = (0,swr__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("/tournament/".concat(router.query.id), ()=>(0,utils_db__WEBPACK_IMPORTED_MODULE_12__/* .fetchEventById */ .HW)(router.query.id));
    const handleSubmit = async (data)=>{
        console.log(data);
        try {
            var _data_startDate;
            await (0,utils_db__WEBPACK_IMPORTED_MODULE_12__/* .updateEvent */ .eJ)(tournament.id, {
                format: data.format,
                title: data.title,
                description: data.description,
                startDate: (_data_startDate = data.startDate) === null || _data_startDate === void 0 ? void 0 : _data_startDate.toISOString(),
                startDateTz: Intl.DateTimeFormat().resolvedOptions().timeZone,
                registrationLink: data.registrationLink,
                organizer: organizer.id,
                onlineEvent: data.onlineEvent,
                location: data.onlineEvent ? null : data.location
            });
            mutate();
        } catch (e) {
            if (e instanceof zod__WEBPACK_IMPORTED_MODULE_14__/* .ZodError */ .jm) {
                const errors = (0,utils_form__WEBPACK_IMPORTED_MODULE_15__/* .mapZodErrorToFinalForm */ .B)(e);
                return {
                    [final_form__WEBPACK_IMPORTED_MODULE_1__/* .FORM_ERROR */ .Ck]: errors.formErrors,
                    ...errors.fieldErrors
                };
            }
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_16__/* .captureException */ .Tb(e);
            return {
                [final_form__WEBPACK_IMPORTED_MODULE_1__/* .FORM_ERROR */ .Ck]: "Si \xe8 verificato un errore."
            };
        }
        router.push("/admin/to/".concat(tournament.organizer.id));
    };
    const handleAutocomplete = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((args, state, utils)=>{
        var _place_types, _place_types1, _place_address_components_find, _place_address_components, _place_address_components_find1, _place_address_components1, _place_address_components_find2, _place_address_components2, _place_address_components_find3, _place_address_components3;
        const [place] = args;
        if (place === undefined) {
            return;
        }
        const name = place.name && !((_place_types = place.types) === null || _place_types === void 0 ? void 0 : _place_types.includes("street_address")) && !((_place_types1 = place.types) === null || _place_types1 === void 0 ? void 0 : _place_types1.includes("route")) ? place.name : "";
        const address = (_place_address_components_find = (_place_address_components = place.address_components) === null || _place_address_components === void 0 ? void 0 : _place_address_components.find((c)=>c.types.includes("route"))) === null || _place_address_components_find === void 0 ? void 0 : _place_address_components_find.long_name;
        const streetNumber = (_place_address_components_find1 = (_place_address_components1 = place.address_components) === null || _place_address_components1 === void 0 ? void 0 : _place_address_components1.find((c)=>c.types.includes("street_number"))) === null || _place_address_components_find1 === void 0 ? void 0 : _place_address_components_find1.long_name;
        const province = (_place_address_components_find2 = (_place_address_components2 = place.address_components) === null || _place_address_components2 === void 0 ? void 0 : _place_address_components2.find((c)=>c.types.includes("administrative_area_level_2"))) === null || _place_address_components_find2 === void 0 ? void 0 : _place_address_components_find2.short_name;
        const city = (_place_address_components_find3 = (_place_address_components3 = place.address_components) === null || _place_address_components3 === void 0 ? void 0 : _place_address_components3.find((c)=>c.types.includes("administrative_area_level_3"))) === null || _place_address_components_find3 === void 0 ? void 0 : _place_address_components_find3.short_name;
        utils.changeValue(state, "location.venue", ()=>name || "");
        utils.changeValue(state, "location.latitude", ()=>place.geometry.location.lat());
        utils.changeValue(state, "location.longitude", ()=>place.geometry.location.lng());
        utils.changeValue(state, "location.address", ()=>address ? streetNumber ? "".concat(address, ", ").concat(streetNumber) : address : "");
        utils.changeValue(state, "location.province", ()=>province || "");
        utils.changeValue(state, "location.city", ()=>city || "");
        autocompleteRef.current.value = "";
    }, []);
    if (isLoadingOrganizer) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            children: "Loading..."
        });
    }
    if (organizer === null || organizer === undefined) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            children: "Not found"
        });
    }
    if (isLoadingTournament) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            children: "Loading..."
        });
    }
    if (tournament === null || tournament === undefined) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            children: "Not found"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Breadcrumb__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                items: [
                    {
                        href: "/admin",
                        text: "I miei negozi"
                    },
                    {
                        text: "Modifica evento"
                    }
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-screen-lg w-full mx-auto pt-4 px-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
                    mutators: {
                        handleAutocomplete
                    },
                    initialValues: {
                        ...tournament,
                        startDate: (0,date_fns_parseISO__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(tournament.startDate)
                    },
                    onSubmit: handleSubmit,
                    render: (param)=>/*#__PURE__*/ {
                        let { handleSubmit , values , submitError , submitting , form  } = param;
                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "text-2xl font-bold my-4",
                                    children: "Modifica evento"
                                }),
                                submitError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-red-600",
                                    children: submitError
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                    name: "title",
                                    render: (param)=>/*#__PURE__*/ {
                                        let { input , meta  } = param;
                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_TextInput__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            title: "Titolo",
                                            name: input.name,
                                            value: input.value,
                                            onChange: input.onChange,
                                            error: meta.error || meta.submitError
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                    name: "format",
                                    render: (param)=>/*#__PURE__*/ {
                                        let { input , meta  } = param;
                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_Dropdown__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            title: "Formato",
                                            name: input.name,
                                            value: input.value,
                                            onChange: input.onChange,
                                            placeholder: "Formato",
                                            error: meta.error || meta.submitError,
                                            options: _constants_formats__WEBPACK_IMPORTED_MODULE_18__/* ["default"].map */ .Z.map((f)=>({
                                                    label: f,
                                                    value: f
                                                }))
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                    name: "startDate",
                                    render: (param)=>/*#__PURE__*/ {
                                        let { input , meta  } = param;
                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_Datetime__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            title: "Quando",
                                            name: input.name,
                                            value: input.value,
                                            onChange: input.onChange,
                                            error: meta.error || meta.submitError
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                    name: "registrationLink",
                                    render: (param)=>/*#__PURE__*/ {
                                        let { input , meta  } = param;
                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_TextInput__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            title: "Link registratione evento",
                                            type: "url",
                                            name: input.name,
                                            value: input.value,
                                            onChange: input.onChange,
                                            error: meta.error || meta.submitError
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                    name: "description",
                                    render: (param)=>/*#__PURE__*/ {
                                        let { input , meta  } = param;
                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_Textarea__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            title: "Descrizione",
                                            name: input.name,
                                            value: input.value,
                                            onChange: input.onChange,
                                            error: meta.error || meta.submitError
                                        });
                                    }
                                }),
                                values.onlineEvent || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-xl font-bold",
                                            children: "Location"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    className: "block font-medium",
                                                    children: "Cerca qui la tua location"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mt-1 relative rounded-md shadow-sm",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_autocomplete__WEBPACK_IMPORTED_MODULE_13__["default"], {
                                                        className: "block w-full border-gray-300 rounded-md",
                                                        // @ts-expect-error
                                                        type: "text",
                                                        placeholder: "Lascia compilare tutto a gooooogle",
                                                        ref: autocompleteRef,
                                                        apiKey: "AIzaSyCMxoFfkKRbF8w3TPyqtOTcimrII1NZBfo",
                                                        onPlaceSelected: (place)=>form.mutators.handleAutocomplete(place),
                                                        language: "it",
                                                        options: {
                                                            componentRestrictions: {
                                                                country: [
                                                                    "it"
                                                                ]
                                                            },
                                                            types: [
                                                                "store",
                                                                "point_of_interest",
                                                                "route"
                                                            ],
                                                            fields: [
                                                                "name",
                                                                "address_components",
                                                                "geometry.location",
                                                                "types"
                                                            ]
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "grid md:grid-cols-2 gap-4",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                                    name: "location.venue",
                                                    render: (param)=>/*#__PURE__*/ {
                                                        let { input , meta  } = param;
                                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_TextInput__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                            title: "Location",
                                                            name: input.name,
                                                            value: input.value,
                                                            onChange: input.onChange,
                                                            error: meta.error || meta.submitError
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                                    name: "location.address",
                                                    render: (param)=>/*#__PURE__*/ {
                                                        let { input , meta  } = param;
                                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_TextInput__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                            title: "Indirizzo",
                                                            name: input.name,
                                                            value: input.value,
                                                            onChange: input.onChange,
                                                            error: meta.error || meta.submitError
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "grid md:grid-cols-3 gap-4",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                                    name: "location.city",
                                                    render: (param)=>/*#__PURE__*/ {
                                                        let { input , meta  } = param;
                                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_TextInput__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                            title: "Citt\xe0",
                                                            name: input.name,
                                                            value: input.value,
                                                            onChange: input.onChange,
                                                            error: meta.error || meta.submitError
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                                    name: "location.province",
                                                    render: (param)=>/*#__PURE__*/ {
                                                        let { input , meta  } = param;
                                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_TextInput__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                            title: "Provincia",
                                                            name: input.name,
                                                            value: input.value,
                                                            onChange: input.onChange,
                                                            error: meta.error || meta.submitError
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                                    name: "location.country",
                                                    render: (param)=>/*#__PURE__*/ {
                                                        let { input , meta  } = param;
                                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_Dropdown__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                            title: "Paese",
                                                            name: input.name,
                                                            value: input.value,
                                                            onChange: input.onChange,
                                                            error: meta.error || meta.submitError,
                                                            options: [
                                                                {
                                                                    label: "Italia",
                                                                    value: "Italy"
                                                                }
                                                            ]
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "grid md:grid-cols-2 gap-4",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                                    name: "location.latitude",
                                                    render: (param)=>/*#__PURE__*/ {
                                                        let { input , meta  } = param;
                                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_NumericInput__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                            title: "Latitudine",
                                                            name: input.name,
                                                            value: input.value,
                                                            onChange: input.onChange,
                                                            error: meta.error || meta.submitError
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                                    name: "location.longitude",
                                                    render: (param)=>/*#__PURE__*/ {
                                                        let { input , meta  } = param;
                                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_NumericInput__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                            title: "Longitudine",
                                                            name: input.name,
                                                            value: input.value,
                                                            onChange: input.onChange,
                                                            error: meta.error || meta.submitError
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white ".concat(submitting ? "bg-gray-600" : "bg-primary"),
                                    children: submitting ? "Salvatagio..." : "Salva"
                                })
                            ]
                        });
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AdminTournamentEdit);


/***/ }),

/***/ 4597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ mapZodErrorToFinalForm; }
/* harmony export */ });
function mapZodErrorToFinalForm(error) {
    return error.formErrors;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [58,688,997,774,888,179], function() { return __webpack_exec__(2023); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);